// Copyright (c) Frisbii GmbH. All rights reserved.
'use strict';

var EntityDetailsController = function ($scope, $routeParams, $http, $modal, Entity, PSPSettings, Customer, User, Invoice, InvoiceDraft, Dunning, 
        ProductInfo, ReconFileImport, ReconFileDownload, RatedItem, MeteredUsage, UserCount, CustomerCount, ContractCount, InvoiceDraftCount, 
        InvoiceCount, DunningCount, ImportWebhookLogs, EntityHierarchy, ThirdPartyIntegrationSettings, $window, ReconFileDownloadByImportFileId,
        PrepaidCard, PrepaidCardCount) {
    $scope.invoiceType = {
        Invoice: "Invoice",
        InvoiceDraft: "InvoiceDraft"
    };
    
    $scope.loadedPages = { };
    $scope.entityDetails = Entity.get({ entityId: $routeParams.entityId }, function (data) {
        $scope.entity = data.Entity;
        $scope.loadedPages['details'] = true;
    });
    
    $scope.$watch('selectedTab', function () {
        loadEntityDetails();
    }, true);    
    
    $scope.selectInvoiceType = 
    { 
        availableOptions: [
            {value: $scope.invoiceType.InvoiceDraft, name: "Drafts"},
            {value: $scope.invoiceType.Invoice, name: "Final"}
        ], 
        selectedOption: {value: $scope.invoiceType.InvoiceDraft, name: "Drafts"}
    };
    
    $scope.search = "";
    $scope.customersCount = '?';
    $scope.contractsCount = '?';
    $scope.invoiceDraftsCount = '?';
    $scope.invoicesCount = '?';
    $scope.dunningsCount = '?';
    $scope.usersCount = '?';
    $scope.prepaidCardsCount = '?';
    $scope.after = null;
    $scope.before = null;

    $scope.selectedTab = $routeParams.selectedTab;

    $scope.entityDetails = Entity.get({entityId: $routeParams.entityId}, function (data) {
        $scope.entity = data.Entity;
        $scope.entityFeatures = data.Features;
    });

    $scope.isMainContentLoading = function () {
        return $http.pendingRequests.filter(function (request) {
            return !request.url.includes('/count');
        }).length > 0;
    };

    $scope.getShift = function (depth) {
        return "            ".repeat(depth);
    }

    $scope.setProductFilter = function (groupid) {
        if (groupid)
            $scope.productfilter = {PlanGroupId: groupid};
        else
            $scope.productfilter = null;
    }
    
    function deleteEbicsThirdPartysettings(id) {
        ThirdPartyIntegrationSettings.delete(id, uponThirdPartyIntegrationDeletion);
    }

    function uponThirdPartyIntegrationDeletion(response) {
        if (response && response.success && response.success === true) {
            alert("Deleted successfully.");
            $scope.thirdPartyIntegrations = ThirdPartyIntegrationSettings.query({ entityId: $routeParams.entityId });
        }
        else {
            alert("Unable to delete.");
        }
    }

    $scope.deleteEbicsSettings = function (id) {
        $scope.confirm("Delete Ebics Settings", "This action cannot be reversed. Are you sure?", () => deleteEbicsThirdPartysettings(id));
    }
    $scope.searchCustomer = function () {
        $scope.customers = $scope.paginator(function (options, callback) {
            return Customer.query(options, function () {
                callback();
                $scope.wasSearching = $scope.search != "";
            });
        }, {entityId: $routeParams.entityId, search: $scope.search}, 20);
    };

    $scope.setProductFilter = function (group) {
        if (group) {
            $scope.productfilter = {PlanGroupId: group.Id};
            $scope.defaultPriceListId = group.DefaultPriceListId.Untyped;
        } else {
            $scope.productfilter = null;
            $scope.defaultPriceListId = null;
        }
    }

    $scope.searchCustomer();

    $scope.toggleDetails = function (data) {
        data.showDetails = !data.showDetails
    };
 
    $scope.isPrepaidCardTabShown = function() {
        return $scope.entityFeatures && $scope.entityFeatures.includes("Epay");
    }

    $scope.downloadReconFile = function (id) {
        var downloadInfo = new ReconFileDownload();
        downloadInfo.$save({id: id}, function () {
            window.location = downloadInfo.Url;
        });
    };

    $scope.downloadReconFileByImportFileId = function (id) {
        var downloadInfo = new ReconFileDownloadByImportFileId();
        downloadInfo.$save({id: id}, function () {
            window.location = downloadInfo.Url;
        });
    };

    function openInNewTabWinBrowser(url) {
        var win = $window.open(url, '_blank');
        win.focus();
    }

    function loginToAdminUI() {
        openInNewTabWinBrowser($scope.entityDetails.AdminLoginUrl);
        $window.location.reload();
    }

    $scope.loginToAdminUI = function () {
        $scope.confirm("Login", "Are you sure?", loginToAdminUI.bind(this));
    }

    //reconciliation imports table processing

    const RECONCILIATION_IMPORT_MODE = Object.freeze({
        'Undefined': 'Undefined',
        'ManualImport': 'ManualImport',
        'DownloadFromBank': 'DownloadFromBank',
    });

    $scope.ReconciliationImportMode = RECONCILIATION_IMPORT_MODE;

    function ReconciliationImportModeHeader(id, name){
        this.id = id;
        this.name = (name);
    }

    let reconciliationImportModeHeaders = [
        new ReconciliationImportModeHeader(RECONCILIATION_IMPORT_MODE.ManualImport, 'Manual file import'),
        new ReconciliationImportModeHeader(RECONCILIATION_IMPORT_MODE.DownloadFromBank, 'Bank statement from {0} requested for the period {1} - {2}'),
        new ReconciliationImportModeHeader(RECONCILIATION_IMPORT_MODE.Undefined, 'Undefined'),
    ];

    function setPeriodFilterDefaults() {
        if (!moment($scope.before).isValid()) {
            $scope.before = null;
        }
        if (!moment($scope.after).isValid()) {
            $scope.after = null;
        }
    }
    
    $scope.searchWebHooks = function () {
        setPeriodFilterDefaults();
        $scope.importWebhookLogs = $scope.paginator(function (options, callback) {
            return ImportWebhookLogs.query(options, function () {
                callback();
            });
        }, {entityId: $routeParams.entityId, before : $scope.before, after : $scope.after }, 10);
    }

    $scope.setHistoryItemHeader = function(importItem)
    {
        let modeHeader = reconciliationImportModeHeaders.find(function (mode) {
            return mode.id === importItem.ImportType;
        });
        
        let name = modeHeader.name;
        if(modeHeader.id == RECONCILIATION_IMPORT_MODE.DownloadFromBank)
        {
            name = name.replace("{0}", importItem.DownloadOptions.BankName)
                    .replace("{1}", importItem.DownloadOptions.From)
                    .replace("{2}", importItem.DownloadOptions.To);
        }
        return name;
    }

    $scope.isAnyPrepaidCardExists = function() {
        return $scope.prepaidCards && $scope.prepaidCards.items.length > 0;
    }

    $scope.filter = {
        customerId: $routeParams.customerId
    };

    function loadEntityDetails() {
        if ($scope.loadedPages[$scope.selectedTab]) return;
        
        if ($scope.selectedTab === undefined || $scope.selectedTab === null)
            $scope.selectedTab='customers';
        
        $scope.loadedPages[$scope.selectedTab]=true;
        
        switch($scope.selectedTab) {
            case 'users': {
                UserCount.query({entityId: $routeParams.entityId}, function (data) {
                    $scope.usersCount = data.Count;
                });
                $scope.users = $scope.paginator(function (options, callback) {
                    return User.query(options, function () {
                        callback();
                    });
                }, {entityId: $routeParams.entityId}, 20);
                break;
            }
            case 'products': {
                $scope.productInfo = ProductInfo.get({entityId: $routeParams.entityId}, function (data) {
                    for (var i = 0; i < data.PlanVariants.length; i++) {
                        var variant = data.PlanVariants[i];
                        var found = false;
                        for (var j = 0; j < data.Plans.length && !found; j++)
                            if (data.Plans[j].Id == variant.PlanId) {
                                found = true;
                                variant.PlanGroupId = data.Plans[j].PlanGroupId;
                            }
                    }
                });
                break;
            }
            case 'customers': {
                CustomerCount.query({entityId: $routeParams.entityId}, function (data) {
                    $scope.customersCount = data.Count;
                });

                ContractCount.query({entityId: $routeParams.entityId}, function (data) {
                    $scope.contractsCount = data.Count;
                });
                $scope.searchCustomer();
                break;
            }
            case 'invoices': {
                InvoiceDraftCount.query({entityId: $routeParams.entityId}, function (data) {
                    $scope.invoiceDraftsCount = data.Count;
                });
                InvoiceCount.query({entityId: $routeParams.entityId}, function (data) {
                    $scope.invoicesCount = data.Count;
                });
                $scope.invoiceDrafts = $scope.paginator(function (options, callback) {
                    return InvoiceDraft.query(options, function () {
                        callback();
                    });
                }, {entityId: $routeParams.entityId}, 100);


                $scope.invoices = $scope.paginator(function (options, callback) {
                    return Invoice.query(options, function () {
                        callback();
                    });
                }, {entityId: $routeParams.entityId}, 100);
                break;
            }
            case 'dunnings': {
                DunningCount.query({entityId: $routeParams.entityId}, function (data) {
                    $scope.dunningsCount = data.Count;
                });
                $scope.dunnings = $scope.paginator(function (options, callback) {
                    return Dunning.query(options, function () {
                        callback();
                    });
                }, {entityId: $routeParams.entityId}, 100);
                break;
            }
            case 'pspsettings': {
                $scope.pspSettings = PSPSettings.query({entityId: $routeParams.entityId});
                break;
            }
            case 'reconimports': {
                $scope.imports = $scope.paginator(function (options, callback) {
                    return ReconFileImport.query(options, function () {
                        callback();
                    });
                }, {entityId: $routeParams.entityId}, 100);
                break;
            }
            case 'rateditems': {
                $scope.ratedItems = $scope.paginator(function (options, callback) {
                    return RatedItem.query(options, function () {
                        callback();
                    });
                }, {entityId: $routeParams.entityId}, 100);
                break;
            }
            case 'meteredusage': {
                $scope.meteredUsages = $scope.paginator(function (options, callback) {
                    return MeteredUsage.query(options, function () {
                        callback();
                    });
                }, {entityId: $routeParams.entityId}, 100);
                break;
            }
            case 'imports': {
                $scope.searchWebHooks();
                break;
            }
            case 'hierarchy': {
                EntityHierarchy.get({ entityId: $routeParams.entityId }, function (data) {
                    if (!data || !data.Breadcrumbs) {
                        return;
                    }

                    $scope.hierarchy = data.Breadcrumbs.map(function (breadcrumb, i) {
                        return {Name: breadcrumb.Name, Id: breadcrumb.Id, Depth: i}
                    }).concat(data.Children.map(function (child) {
                        return {Name: child.Name, Id: child.Id, Depth: data.Breadcrumbs.length}
                    }));
                });
                break;
            }
            case 'thirdpartyintegrations': {
                $scope.thirdPartyIntegrations = ThirdPartyIntegrationSettings.query({entityId: $routeParams.entityId});
                break;
            }
            case 'prepaidcards': {
                $scope.loadPrepaidCards = function () {
                    var selectedType = $scope.filter.prepaidCardType ? $scope.filter.prepaidCardType : null;

                    PrepaidCardCount.query({
                        serialNumber: $scope.filter.serialNumber,
                        contractId: $scope.filter.contractId,
                        before: $scope.filter.before,
                        after: $scope.filter.after,
                        min: $scope.filter.from,
                        prepaidCardType: selectedType,
                        customerId : $scope.filter.customerId,
                        entityId: $routeParams.entityId
                    }, function(data) {
                        $scope.prepaidCardsCount  = data.Count;
                    });

                    $scope.prepaidCards = $scope.paginator(function(options, callback) {
                            return PrepaidCard.query(options, function() { callback(); });
                        },
                        {
                            serialNumber: $scope.filter.serialNumber,
                            contractId: $scope.filter.contractId,
                            before: $scope.filter.before,
                            after: $scope.filter.after,
                            min: $scope.filter.from,
                            prepaidCardType: selectedType,
                            customerId : $scope.filter.customerId,
                            entityId: $routeParams.entityId
                        },
                        20);
                };

                $scope.loadPrepaidCards();
            }
        }
    }    
};

EntityDetailsController.$inject = ['$scope', '$routeParams', '$http', '$modal', 'Entity', 'PSPSettings', 'Customer', 'User', 'Invoice', 'InvoiceDraft', 'Dunning', 'ProductInfo', 'ReconFileImport', 'ReconFileDownload', 'RatedItem', 'MeteredUsage', 'UserCount', 'CustomerCount', 'ContractCount', 'InvoiceDraftCount', 'InvoiceCount', 'DunningCount', 'ImportWebhookLogs', 'EntityHierarchy', 'ThirdPartyIntegrationSettings', '$window', 'ReconFileDownloadByImportFileId', 'PrepaidCard', 'PrepaidCardCount'];
